var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F01",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.3 858l6.187-6.187c.684-.683.684-1.792 0-2.474l-.825-.825c-.683-.684-1.792-.684-2.474 0l-6.187 6.187-6.188-6.188c-.683-.684-1.792-.684-2.474 0l-.826.825c-.684.683-.684 1.792 0 2.474l6.188 6.189-6.187 6.187c-.684.684-.684 1.792 0 2.474l.825.825c.683.684 1.792.684 2.474 0l6.188-6.187 6.187 6.187c.684.684 1.792.684 2.474 0l.825-.825c.684-.683.684-1.792 0-2.474L1343.3 858z",
    transform: "translate(-1330.000000, -848.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCancel);
export default __webpack_public_path__ + "static/media/user-cancel.ad56fdfcfc78951b319c788d2a26d76f.svg";
export { ForwardRef as ReactComponent };